import { ApplicationState } from '../index';

/**
 * Is the Run Audit Workpapers modal currently active (shown).
 *
 * @returns true if the modal should be shown.
 */

export function GetRunAuditWorkpapersModalActive(state: ApplicationState): boolean {
    return (state && state.runAuditWorkpapers) ? state.runAuditWorkpapers.modalActive : false;
}

/**
 * The workspace (entity) id for the submission the modal was launched from.
 *
 * @returns the workspace id or an empty string if the modal is not active.
 */

export function GetRunAuditWorkpapersWorkspaceId(state: ApplicationState): string {
    return (state && state.runAuditWorkpapers) ? state.runAuditWorkpapers.workspaceId : '';
}

/**
 * The submission id the Run Audit Workpapers button was clicked on.
 *
 * @returns the submission id or an empty string if the modal is not active.
 */

export function GetRunAuditWorkpapersSubmissionId(state: ApplicationState): string {
    return (state && state.runAuditWorkpapers) ? state.runAuditWorkpapers.submissionId : '';
}

/**
 * The financial record id for the submission the modal was launched from.
 *
 * @returns the financial record id or an empty string if the modal is not active.
 */

export function GetRunAuditWorkpapersFinancialRecordId(state: ApplicationState): string {
    return (state && state.runAuditWorkpapers) ? state.runAuditWorkpapers.financialRecordId : '';
}
